import React from 'react'

import ChassiPlataforma from './ChassiPlataforma'
import Cover from './Cover'
import Separator from '../../../../../components/helpers/Separator'

const ChassiPlataformaContent = ({ headerValues, moslerValues, diagSegValues }) => {
  return (
    <>
      <Cover
        headerValues={{
          ...headerValues,
          tipo: 'CHECKLIST - DIAGNÓSTICO DE SEGURANÇA',
          titulo: 'ANEXO 01 - CAPA CHASSI'
        }}
      />
      <Separator weight={10} />
      <ChassiPlataforma headerValues={headerValues} moslerValues={moslerValues} diagSegValues={diagSegValues} />
    </>
  )
}

export default ChassiPlataformaContent
